import appConfig from "../../../config/appConfig";
import { Role, Roles } from "../../../context/userinfo/types";
import { isAuthorisedRole } from "../../../utils/utils";
import { Filters } from "./types";

export const filterNameDisplayLabelMapping: Partial<Record<keyof Filters, string>> = {
  type: "Event type",
  fp_object_id: "FP object id",
  date_range: "Date range",
};

export const EVENTS_AUTHORISED_ROLES = [
  Role.CUSTOMER_SUCCESS,
  Role.CYBRILLA_ADMIN,
  Role.TENANT_ROOT,
];

export const canAccessEvents = (currentRoles: Roles | undefined) =>
  appConfig.app.is_events_enabled && isAuthorisedRole(EVENTS_AUTHORISED_ROLES, currentRoles);
